import React, { useContext, useEffect, useState } from 'react';
import LabelTranslated from '../../b2b-languages/components/LabelTranslated';
import { LoginContext } from '../../../App';
import { generateTextField } from '../../b2b-common/helpers';

import './LevelNFields.css';

const LevelNFields = ({ levelN }) => {
    const [currentLevelN, setCurrentLevelN] = useState(levelN);
    const { loginData } = useContext(LoginContext);

    useEffect(() => {
        setCurrentLevelN(levelN);
    }, [levelN]);

    //console.log('LevelNFields: ', currentLevelN);

    return (
        <div className='leveln-fields'>
            <div className='leveln-fields-short-elements'>
                {generateTextField("Id", currentLevelN.levelN_ItemStrId, "leveln-field-id", false, null, { required: false })}
                <LabelTranslated field="Short name" labelValue={currentLevelN.levelN_ItemShortName_label}
                    locale={`Short name - ${loginData.locale}`} translation={currentLevelN.levelN_ItemShortName} />
            </div>
            <div className='leveln-fields-long-elements'>
                <LabelTranslated field="Name" labelValue={currentLevelN.levelN_ItemName_label}
                    locale={`Name - ${loginData.locale}`} translation={currentLevelN.levelN_ItemName} />
                <LabelTranslated field="Description" labelValue={currentLevelN.levelN_ItemDescription_label}
                    locale={`Description - ${loginData.locale}`} translation={currentLevelN.levelN_ItemDescription}
                    rowsNumber={4} />
            </div>
        </div>
    );
};

export default LevelNFields;